import 'regenerator-runtime/runtime';

import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import { applyMiddleware, compose, createStore } from 'redux';
import { thunk } from 'redux-thunk';
import { Startup } from './App';
import { appContext } from './AppContext';
import { routes } from './RoutesV2';
import reducer from './reducer';
import { GoFormzThemeProvider } from './theme';

import(/* webpackChunkName: "styles" */ './styles/global.scss');
import(/* webpackChunkName: "oldstyles" */ '../scss/main.scss');

export default async function Library(id: string) {
  await Startup();

  // we are creating a Browser instance here to leverage the new
  // data api introduced by v6.4.
  // the data apis allows us to fully customize navigation blocking required by our
  // old <RouterPrompt /> component
  // https://reactrouter.com/en/main/routers/picking-a-router#using-v64-data-apis
  const gfRouter = createBrowserRouter(routes);

  const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
        // extension options
        // https://github.com/zalmoxisus/redux-devtools-extension/blob/master/docs/API/Arguments.md
      })
    : compose;

  // todo - replace with @reduxjs/toolkit
  const store = createStore(reducer, composeEnhancers(applyMiddleware(thunk)));

  appContext.store = store;

  const rootContainer = () => (
    <Provider store={store}>
      <GoFormzThemeProvider>
        <RouterProvider router={gfRouter} />
      </GoFormzThemeProvider>
    </Provider>
  );

  ReactDOM.render(rootContainer(), document.getElementById(id));

  if ((module as ExplicitAny).hot) {
    (module as ExplicitAny).hot.accept('./RoutesV2', () => {
      ReactDOM.render(rootContainer(), document.getElementById(id));
    });
  }
}
